module.exports = __webpack_public_path__ + "img/mobileapp.95b47ff2.png";